module.exports = __webpack_public_path__ + "img/homework_icon.8ecd555a.png";